import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocGlobalMaintenanceRoute: InvariantJiraRoute = {
	name: 'eoc-global-maintenance',
	path: '/jira/settings/products/ops/maintenance',
	exact: true,
};
